module.exports = __webpack_public_path__ + "static/media/logo_quickspin.2e801306.svg";